<template>
    <div class="office">
        <OfficeBanner :data="navData.city" :menuActiveIndex="cityActiveIndex" @change="cityChange"/>
        <div class="container">
            <div class="main">
                <div class="images" v-if="navData.city.length > 0">
                    <ImagesBanner 
                    :data="navData.city[cityActiveIndex].project_pc2" 
                    :mobileData="navData.city[cityActiveIndex].project"
                    :name="navData.city[cityActiveIndex].city_name"/>
                </div>
                <div class="office_text" id="flex">
                    <p class="title">灵活空间产品</p>
                    <p class="desc">从移动工位到专属办公室，再到整个企业总部，我们都能打造出可提高工作效率、创新和协作的办公环境。</p>
                </div>
                <OfficeSpace :data="navData.product"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ImagesBanner from '../../components/imagesBanner.vue';
import OfficeBanner from '../../components/officeBanner.vue';
import OfficeSpace from '../../components/officeSpace.vue';
export default {
    name: "office",
    data() {
        return {
            cityActiveIndex: 0,
        };
    },
    computed: {
        ...mapState([ 'navData' ])
    },
    components: {
        OfficeBanner,
        ImagesBanner,
        OfficeSpace
        
    },
    mounted() {
        for (let i = 0; i < this.navData.city.length; i++) {
            const item = this.navData.city[i];
            if(`#${item.city_name}` == this.$route.hash){
                this.cityActiveIndex = i;
                break;
            }
        }
    },
    watch: {},
    methods: {
        cityChange(index){
            this.cityActiveIndex = index;
        }
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.main{
    padding: .8rem 0;
    @media only screen and (max-width: 1200px) {
        padding: 1.7rem 0;
    }
}
.images{
    margin-bottom: .8rem;
    @media only screen and (max-width: 1200px) {
        margin-bottom: 0;
    }
}
.office_text{
    .title{
        font-size: .32rem;
        margin-bottom: .2rem;
    }
    .desc{
        line-height: 1.8;
    }
    @media only screen and (max-width: 1200px) {
        padding: 1.2rem 1rem;
        .title{
            font-size: .72rem;
            margin-bottom: .5rem;
            text-align: center;
        }
    }
}
</style>